import { Types } from "../actions/BreakdownReasonPlaceActions";

const initialState = {
    Loading: false,
    isTaskUpdated: false,
    plants: {},
    breakdownGroups: {},
    breakdownReasonPlaces: {},
};

export const BreakdownReasonPlaceReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_BREAKDOWN_REASON_PLACES:
            return {
                ...state,
            };
        case Types.SET_BREAKDOWN_REASON_PLACE:
            return {
                ...state,
                breakdownReasonPlaces: action.payload ?? state.breakdownReasonPlaces,
            };
        case Types.SET_PLANTS:
            return {
                ...state,
                plants: action.payload ?? state.plants,
            };
        case Types.SET_BREAKDOWN_GROUPS:
            return {
                ...state,
                breakdownGroups: action.payload ?? state.breakdownGroups,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
